import React, { Component } from "react";
import PropTypes from "prop-types";

class SingleValueForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
      invalid: false
    };
  }

  onChange = value => {
    this.setState({
      value,
      invalid: false
    });
  };

  onSubmit = event => {
    event.preventDefault();
    let { value } = this.state;

    if (this.props.trim === true) {
      value = value.trim();
    }

    if (value.length > 0) {
      this.props.onSubmit(value);
    } else {
      this.setState({ invalid: true });
    }
  };

  render = () => (
    <form onSubmit={this.onSubmit}>
      {this.props.render({ ...this.state, onChange: this.onChange })}
    </form>
  );
}

SingleValueForm.defaultProps = {
  value: ""
};

SingleValueForm.displayName = "SingleValueForm";

SingleValueForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  trim: PropTypes.bool,
  value: PropTypes.string
};

export default SingleValueForm;
